const orderStatus = ['pending', 'confirm', 'decline'];

export const OrderStatus = orderStatus.map((status) => status.toUpperCase());

export const classNames = (
  ...classes: Array<string | undefined | null | false>
) => {
  return classes.filter(Boolean).join(' ');
};

const currencies = [
  {
    code: 'GHS',
    name: 'Ghana Cedi',
    symbol: '₵',
    country: 'GH',
  },
  {
    code: 'NGN',
    name: 'Nigerian Naira',
    symbol: '₦',
    country: 'NG',
  },
  {
    code: 'ZAR',
    name: 'South African Rand',
    symbol: 'R',
    country: 'ZA',
  },
];

export const currencyCode = (country: string) => {
  const currency = currencies.find((currency) => currency.country === country);
  return currency?.code ?? 'GHS';
};
